// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"184":"60b1c643","743":"73cebb1c","767":"73f3898f","781":"f23c07ba","993":"73cebb1c"}[chunkId] + ".css";
};